import { CapaServiceType } from '@generated/graphql';
import jwtDecode from '@utils/jwtDecode';
import { useCallback, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../modules/index';
import {
  initClient,
  createTempClient,
  getClient,
  getClientToken,
  updateRedirectPath,
  updateClient,
  updateToken
} from '../modules/client/index';
import { IClientState, Token } from '../modules/client/types';

function useClient() {
  // state
  const clientState = useSelector((state: RootState) => state.client);

  // dispatch functions
  const dispatch = useDispatch();
  const onInitClient = useCallback(() => dispatch(initClient()), [dispatch]);
  const onCreateTempClient = useCallback(
    (payload: Partial<IClientState>) => dispatch(createTempClient(payload)),
    [dispatch]
  );
  const onGetClient = useCallback(
    (payload: Partial<IClientState>) => dispatch(getClient(payload)),
    [dispatch]
  );
  const onGetClientToken = useCallback(
    (payload: Token) => dispatch(getClientToken(payload)),
    [dispatch]
  );
  const onUpdateClient = useCallback(
    (payload: Partial<IClientState>) => dispatch(updateClient(payload)),
    [dispatch]
  );
  const onUpdateRedirectPath = useCallback(
    (payload: string) => dispatch(updateRedirectPath(payload)),
    [dispatch]
  );
  const onUpdateToken = useCallback(
    (payload: Token) => dispatch(updateToken(payload)),
    [dispatch]
  );
  const hasRequiredInfo = useMemo(() => {
    if (clientState.accessToken && clientState.refreshToken) {
      const jwt = jwtDecode();
      const { managerName, cellphoneNumber } = clientState;

      const requiredInfo = [managerName, cellphoneNumber];

      return Boolean(
        jwt?.scopes.includes(CapaServiceType.Quotation) &&
          requiredInfo.every((el) => Boolean(el))
      );
    }
    return false;
  }, [clientState]);

  return {
    clientState,
    onInitClient,
    onCreateTempClient,
    onGetClient,
    onGetClientToken,
    onUpdateToken,
    onUpdateRedirectPath,
    onUpdateClient,
    hasRequiredInfo
  };
}

export default useClient;
